import { render, staticRenderFns } from "./OrganizationInfo.partial.view.vue?vue&type=template&id=388a9021&"
import script from "./OrganizationInfo.partial.view.vue?vue&type=script&lang=js&"
export * from "./OrganizationInfo.partial.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388a9021')) {
      api.createRecord('388a9021', component.options)
    } else {
      api.reload('388a9021', component.options)
    }
    module.hot.accept("./OrganizationInfo.partial.view.vue?vue&type=template&id=388a9021&", function () {
      api.rerender('388a9021', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/client-space/supplier/organization-reliability-report/OrganizationInfo.partial.view.vue"
export default component.exports